import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
  calculatePossibleMoves,
  calculateAllPossibleStatesForPC,
  performMove,
  checkIfStateIsContained,
} from './utils/moves.js'

var arraysMatch = function(arr1, arr2) {
  // Check if the arrays are the same length
  if (arr1.length !== arr2.length) return false

  // Check if all items exist and are in the same order
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }

  // Otherwise, return true
  return true
}

const store = new Vuex.Store({
  state: {
    model: calculateAllPossibleStatesForPC([1, 1, 1, 0, 0, 0, 2, 2, 2]).map(
      (state, index) => {
        const possibleMoves = calculatePossibleMoves(state, 2)
        return {
          state: state,
          actions: possibleMoves,
          sweets: new Array(possibleMoves.length).fill(1),
          index: index,
        }
      }
    ),
    // actually ... one should do this with an array
    lastlastSituation: -2,
    lastSituation: -1,
    lastlastActionTaken: -2,
    lastActionTaken: -1,
  },

  getters: {
    getObjectForStateIndex: (storeState) => (index) => {
      return storeState.model[index]
    },
    actionAlreadySelected: (storeState, getters) => (state) => {
      const indexForState = getters.findObjectForState(state)
      if (indexForState < 0) {
        //state not found
        return true
      }

      return storeState.model[indexForState].sweets.reduce(
        (accumulator, currentValue) => accumulator + currentValue
      ) > 1
        ? false
        : true
    },
    getFilteredStates: (storeState) => (state) => {
      if (!storeState.filter) {
        return storeState.model
      }

      let relevantStates = []
      const moves = calculatePossibleMoves(state, 1)
      for (let index in moves) {
        relevantStates.push(performMove([...state], moves[index]))
      }

      return storeState.model.filter((x) =>
        checkIfStateIsContained(relevantStates, x.state)
      )
    },

    findObjectForState: (storeState) => (state) => {
      for (let i = 0; i < storeState.model.length; i++) {
        let thisOneIsIt = true
        for (let j = 0; j < state.length; j++) {
          if (storeState.model[i].state[j] != state[j]) {
            thisOneIsIt = false
          }
        }
        if (thisOneIsIt) {
          return i
        }
      }
      return -1
    },

    choosePlayType: (storeState, getters) => (state) => {
      const indexForState = getters.findObjectForState(state)
      if (indexForState < 0) {
        //state not found
        return
      }

      // if there are multiple options, wait for player to select a move
      if (storeState.model[indexForState].sweets.reduce((a, b) => a + b) > 1) {
        // too much sweets --> no selection made
        // throw 'USER_DID_NOT_CHOOSE_YET'
      }

      const arrayForRandomSelect = storeState.model[indexForState].sweets
        .map((sweet, index) => new Array(sweet).fill(index))
        .flat()

      const selectedMove =
        arrayForRandomSelect[
          Math.floor(Math.random() * arrayForRandomSelect.length)
        ]
      storeState.lastlastSituation = storeState.lastSituation
      storeState.lastSituation = indexForState
      storeState.lastlastActionTaken = storeState.lastActionTaken
      storeState.lastActionTaken = selectedMove
      return [
        storeState.model[indexForState].actions[selectedMove],
        selectedMove,
      ]
    },
  },
  mutations: {
    update(storeState, payload) {
      let stateToChange = storeState.model.find((playSituation) =>
        arraysMatch(playSituation.state, payload.state)
      )
      let newValue = new Array(stateToChange.sweets.length).fill(0)
      newValue[payload.index] = 1
      Vue.set(stateToChange, 'sweets', newValue)
    },

    flipFilter(storeState) {
      Vue.set(storeState, 'filter', !storeState.filter)
    },
  },
})

export default store
